import React from 'react';
import styled from 'styled-components';

const RootContainer = styled.div`
	display: flex;
	flex-direction: column;
	margin-bottom: 20px;
`;

const TextInputElement = styled.textarea`
	border-radius: 5px;
	border-color: ${(props) => (props.border ? '#ff0000' : '#ececec')};
	border-width: 1px;
	border-style: solid;
	height: 30px;
	padding: 10px;
`;

const InputTitle = styled.div`
	margin-bottom: 10px;
	color: #606060;
`;

const TextArea = ({ type, title, border, ...rest }) => {
	return (
		<RootContainer>
			<InputTitle>{title}</InputTitle>
			<TextInputElement rows="10" cols="100" border={border} type={type} {...rest} />
		</RootContainer>
	);
};

export default TextArea;
